import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import enTranslations from './locales/en.json'
import deTranslations from './locales/de.json'
import huTranslations from './locales/hu.json'

const resources = {
  en: {
    translation: enTranslations
  },
  de: {
    translation: deTranslations
  },
  hu: {
    translation: huTranslations
  }
}

// Get the saved language or default to English with error handling
let savedLanguage = 'en'
try {
  const stored = localStorage.getItem('i18nextLng')
  if (stored && ['en', 'de', 'hu'].includes(stored)) {
    savedLanguage = stored
  } else {
    // If invalid language is stored, clear it
    localStorage.removeItem('i18nextLng')
  }
} catch (error) {
  console.warn('localStorage not available, using default language')
}
const initialLanguage = savedLanguage

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage,
    fallbackLng: 'en',
    supportedLngs: ['en', 'de', 'hu'],
    debug: false, // Disable debug to reduce console noise
    
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    
    react: {
      useSuspense: false, // Disable suspense to prevent hanging
    },
  })

// Handle initialization errors gracefully
if (i18n.isInitialized) {
  console.log('i18n initialized successfully')
} else {
  i18n.on('initialized', () => {
    console.log('i18n initialized successfully')
  })
}

// Export a function to change language and save to localStorage
export const changeLanguage = (lng: string) => {
  try {
    localStorage.setItem('i18nextLng', lng)
  } catch (error) {
    console.warn('Could not save language to localStorage')
  }
  return i18n.changeLanguage(lng)
}

export default i18n 